import './App.css';
import {  Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Certificates from './pages/Certificates';

function App() {
  return (
    <div className="min-h-screen ">
      <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/certificate/:id" element={<Certificates />} />

</Routes>
    </div>
  );
}

export default App;
